import React, {useMemo} from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import User, {UserId} from 'records/User';
import {IdMap} from '@store/@types/util';

interface UserSelectorProps {
  users: IdMap<User>;
  value: UserId | undefined | null;
  onChange: (userId: UserId | null) => void;
  onSearchChange?: (search: string) => void;
  sessionUser?: User;
  fullWidth?: boolean;
  placeholder?: string;
  disabled?: boolean;
  noOptionsText?: string;
}

export function UserSelector({
  disabled,
  fullWidth,
  onChange,
  placeholder,
  sessionUser,
  users,
  value,
  noOptionsText,
  onSearchChange,
}: UserSelectorProps) {
  const options: UserId[] = useMemo(() => {
    const sortUsers = (a: UserId, b: UserId) => {
      const userA = users.get(a)!;
      const userB = users.get(b)!;
      return userA.getFullName().localeCompare(userB.getFullName());
    };

    return users.keySeq().sort(sortUsers).toArray();
  }, [users]);

  return (
    <Autocomplete
      className="user-selector"
      fullWidth={fullWidth}
      filterSelectedOptions
      renderInput={params => (
        <TextField
          className="user-selector-input"
          {...params}
          placeholder={placeholder}
          size="small"
          variant="outlined"
          onChange={event => onSearchChange?.(event.target.value)}
        />
      )}
      options={options}
      value={value}
      getOptionLabel={id => (id === sessionUser?.id ? 'Me' : users.get(id)!.getFullName())}
      onChange={(e, userId) => onChange(userId)}
      disabled={disabled}
      noOptionsText={noOptionsText}
    />
  );
}
